import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Craftsmanship from "@/components/sections/Craftsmanship";
import Collection from "@/components/sections/Collection";
import NewLaunch from "@/components/sections/NewLaunch";
import Moodboard from "@/components/sections/Moodboard";
import Testimonials from "@/components/sections/Testimonials";
import Appointment from "@/components/sections/Appointment";

export default function Home() {
    const { hash } = useLocation();

    useEffect(() => {
        if (hash) {
            const el = document.querySelector(hash);
            if (el) {
                setTimeout(
                    () => el.scrollIntoView({ behavior: "smooth", block: "start" }),
                    200,
                );
            }
        }
    }, [hash]);

    return (
        <main data-testid="home-page" className="relative">
            <Hero />
            <About />
            <Craftsmanship />
            <Collection />
            <NewLaunch />
            <Moodboard />
            <Testimonials />
            <Appointment />
        </main>
    );
}
